import Vue from 'vue'
import Vuex from 'vuex'
import app from './modules/app'
import user from './modules/user'
import getters from './getters'
// import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    app,
    user
  },
  getters,
  // plugins: [
  //   createPersistedState({
  //     storage: window.localStorage,
  //     reducer (state) {
  //       return {
  //         u_id: state.u_id, // 持久化
  //         username: state.username,
  //       }
  //     }
  //   })
  // ]
})

export default store
